import { render, staticRenderFns } from "./ScreeningCustomer.vue?vue&type=template&id=16c50bc7&scoped=true"
import script from "./ScreeningCustomer.vue?vue&type=script&lang=js"
export * from "./ScreeningCustomer.vue?vue&type=script&lang=js"
import style0 from "./ScreeningCustomer.vue?vue&type=style&index=0&id=16c50bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c50bc7",
  null
  
)

export default component.exports